import { mapActions, mapState, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('supplierProducts', ['getFormattedProduct']),

        ...mapState('categories', ['categories']),
        ...mapState('types', ['types']),
        ...mapState('caseShapes', ['caseShapes']),
        ...mapGetters('types', ['getTypeByCategory']),
        ...mapState('materials', ['materials']),
        ...mapState('finenesses', ['finenesses']),
        ...mapGetters('finenesses', ['getFinenessByMaterial']),
        ...mapState('colors', ['colors']),
        ...mapState('technologies', ['technologies']),
        ...mapState('decor', ['decor']),
        ...mapState('purposes', ['purposes']),
        ...mapGetters('purposes', ['getPurposesByType']),
        ...mapState('genders', ['genders']),
        ...mapState('insert', [
            'insertMaterials',
            'insertColors',
            'insertFacets'
        ]),
        ...mapState('supplierBrand', ['brands']),
        ...mapState('supplierCollections', ['collections'])
    },
    mounted() {
        if (!this.types.length) {
            this.getTypes()
        }
        if (!this.categories.length) {
            this.getCategories({ sort_by: 'Position' })
        }
        if (!this.materials.length) {
            this.getMaterials()
        }
        if (!this.finenesses.length) {
            this.getFineness()
        }
        if (!this.colors.length) {
            this.getColors()
        }
        if (!this.decor.length) {
            this.getDecor()
        }
        if (!this.purposes.length) {
            this.getPurposes()
        }
        if (!this.genders.length) {
            this.getGenders()
        }
        if (!this.insertMaterials.length) {
            this.getInsertMaterials()
        }
        if (!this.insertColors.length) {
            this.getInsertColors()
        }
        if (!this.insertFacets.length) {
            this.getInsertFacets()
        }
        if (!this.brands.length) {
            this.getBrands()
        }
        if (!this.collections.length) {
            this.getCollections()
        }
        if (!this.technologies.length) {
            this.getTechnologies()
        }
        if (!this.caseShapes.length) {
            this.getCaseShapes()
        }
    },
    methods: {
        ...mapActions('categories', ['getCategories']),
        ...mapActions('types', ['getTypes']),
        ...mapActions('materials', ['getMaterials']),
        ...mapActions('finenesses', ['getFineness']),
        ...mapActions('colors', ['getColors']),
        ...mapActions('technologies', ['getTechnologies']),
        ...mapActions('decor', ['getDecor']),
        ...mapActions('purposes', ['getPurposes']),
        ...mapActions('genders', ['getGenders']),
        ...mapActions('caseShapes', ['getCaseShapes']),
        ...mapActions('insert', [
            'getInsertMaterials',
            'getInsertColors',
            'getInsertFacets'
        ]),
        ...mapActions('supplierBrand', ['getBrands']),
        ...mapActions('supplierCollections', ['getCollections'])
    }
}
